// extracted by mini-css-extract-plugin
module.exports = {"price":"t0","inverted":"t1","separator":"t2","strikeout":"t3","discount":"t4","preliminaryValue":"t5","gray":"t6","locked":"t7","finalPrice":"t8"};